import { render, staticRenderFns } from "./acordos_tabs.vue?vue&type=template&id=4dd725bf"
import script from "./acordos_tabs.vue?vue&type=script&lang=js"
export * from "./acordos_tabs.vue?vue&type=script&lang=js"
import style0 from "./acordos_tabs.vue?vue&type=style&index=0&id=4dd725bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTab,VTabs})
